import { Box, Grid, Typography } from '@mui/material';
import '../styles/SectionC.scss';
import SectionCCard from './SectionCCard';
import ayyappan from '../../../../../../app/assets/images/landing/Iyyapan.jpg';
import mani from '../../../../../../app/assets/images/landing/mani.jpg';
// import { Fade} from "react-awesome-reveal";
import sectionConstants from '../../constants/SectionConstants';


const constants = [
  {
    id: 1,
    img: ayyappan,
    name: 'Ayyappan V',
    title: 'Founder/CEO',
    content:
      'Mr. Ayyappan V, with 30 years in IT, ventures to innovate in IT, healthcare, education, logistics and agriculture. Committed to user-centric solutions, he propels global expansion through R&D and employee empowerment.'
  },
  {
    id: 2,
    img: mani,
    name: 'Navarathinamani P',
    title: 'Co-Founder/COO',
    content:
      'Mr. Navarathinamani P, with 25 years of IT experience, champions innovation in IT, healthcare, education, logistics and agriculture. Prioritizing job creation, inclusive growth, and client trust, his products serve industry needs with social value.'
  }
];

const SectionC = () => {
  return (
    <Box className='section-c' mt={2}>
      <Box className='title'>
        <Typography  className='section-c-heading primary-color' >{sectionConstants.OurTeam}</Typography>
        <Typography  className='section-c-heading' color='black'>{sectionConstants.MeetOurDirectors}</Typography>
      </Box>
      <Grid container className='card'>
        {constants.map(({ id, img, name, title, content }) => (
          <Grid item md={4}p={2} ml={15}>
            <SectionCCard
              key={id}
              img={img}
              name={name}
              title={title}
              content={content}
            />
          </Grid>
        ))}
      </Grid>
     
    </Box>
  );
};

export default SectionC;
